export default "__VITE_ASSET__6b718c04__"